// Import the log module directly from libx.js source: libx.js's main bundle
// doesn't re-export `log` as a named ESM export, and source-importing keeps
// libx.js patches live (no rebuild) — matching the `bun link` workflow.
import { log } from 'libx.js/src/modules/log';

/** Component-scoped logger (libx.js). debug/verbose gated via DEBUG env/localStorage. */
export const forComponent = (name: string) => log.forComponent(name);
export { log };
